import { Airplay, Feed, Feedback, Gavel, Info, NewReleases, Phone, Policy, Search } from "@mui/icons-material";
import { Alert, Box, DialogContent, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import FullScreenDialog from "../full-screen-dialog/FullScreenDialog";
import SettingsBar from "../settings-bar/SettingsBar";
import appSettingsJson from "../../app-settings.json";

const _searchHelpFilesHref = "https://support.elynxtech.com/hc/en-us";
const _contactSupportHref = "https://support.elynxtech.com/hc/en-us/requests/new";
const _submitProductIdeaHref = "https://support.elynxtech.com/hc/en-us/community/topics/115000546908-Feature-Requests";
const _recentUpdatesHref = "https://support.elynxtech.com/hc/en-us/categories/360000723614-Release-Notes";
const _termsOfServiceHref = "https://www.elynxtech.com/terms-and-conditions";
const _privacyPolicyHref = "https://www.iubenda.com/privacy-policy/70098978";
const _hardwareOrderHref = "https://support.elynxtech.com/hc/en-us/articles/216690648-Hardware-Order-Form";


// var CobrowseIO: any = (window as any).CobrowseIO;

export default function HelpMenu({ ...props }: any) {

    const [cobrowseCode, setCobrowseCode] = useState<string>();

    const { t } = useTranslation();

    const handleHelpMenuClick = (href: string) => {
        props?.onClose();
        setTimeout(() =>
            window.open(href), 0);
    };

    const handleCobrowseMenuClick = async () => {

        const CobrowseIO: any = (window as any).CobrowseIO;

        await CobrowseIO.client();

        CobrowseIO.start({
            register: false
        });

        const code = await CobrowseIO.createSessionCode();

        setCobrowseCode(code);

        console.log(`remote session code is: ${code}`)
        

    }

    const appVersion = appSettingsJson.appVersion;

    return (
            <FullScreenDialog
                aria-labelledby="form-dialog-title"
                open={props.open}
                onClose={() => props?.onClose()}
            >
                <SettingsBar
                    title={t("helpMenu.help")}
                    onClose={() => {
                        props?.onClose();
                    }}
                    hideAction={true}
                />

                <DialogContent>
                    <Typography variant="h5">{t("helpMenu.onlineHelp")}</Typography>

                    <Stack direction="row" spacing={4} sx={{ marginTop: 2, cursor: "pointer" }} onClick={() => handleHelpMenuClick(_contactSupportHref)}>
                        <Phone fontSize="medium" />
                        <Box>
                            <Typography variant="body1">{t("helpMenu.contactSupport")}</Typography>
                            <Typography variant="body2">{t("helpMenu.contactSupportDescription")}</Typography>
                        </Box>
                    </Stack>

                    <Stack direction="row" spacing={4} sx={{ marginTop: 2, cursor: "pointer" }} onClick={() => handleHelpMenuClick(_searchHelpFilesHref)}>
                        <Search fontSize="medium" />
                        <Box>
                            <Typography variant="body1">{t("helpMenu.searchHelp")}</Typography>
                            <Typography variant="body2">{t("helpMenu.searchHelpDescription")}</Typography>
                        </Box>
                    </Stack>

                    <Typography variant="h5" sx={{marginTop: 4}}>{t("helpMenu.assistance")}</Typography>

                    <Stack direction="row" spacing={4} sx={{ marginTop: 2, cursor: "pointer" }} onClick={() => handleHelpMenuClick(_recentUpdatesHref)}>
                        <NewReleases fontSize="medium" />
                        <Box>
                            <Typography variant="body1">{t("helpMenu.recentUpdates")}</Typography>
                            <Typography variant="body2">{t("helpMenu.recentUpdatesDescription")}</Typography>
                        </Box>
                    </Stack>

                    <Stack direction="row" spacing={4} sx={{ marginTop: 2, cursor: "pointer" }} onClick={() => handleHelpMenuClick(_submitProductIdeaHref)}>
                        <Feedback fontSize="medium" />
                        <Box>
                            <Typography variant="body1">{t("helpMenu.submitIdea")}</Typography>
                            <Typography variant="body2">{t("helpMenu.submitIdeaDescription")}</Typography>
                        </Box>
                    </Stack>

                    <Stack direction="row" spacing={4} sx={{ marginTop: 2, cursor: "pointer" }} onClick={() => handleHelpMenuClick(_hardwareOrderHref)}>
                        <Feed fontSize="medium" />
                        <Box>
                            <Typography variant="body1">{t("helpMenu.hardwareOrder")}</Typography>
                            <Typography variant="body2">{t("helpMenu.hardwareOrderDescription")}</Typography>
                        </Box>
                    </Stack>


                    <Stack direction="row" spacing={4} sx={{ marginTop: 2, cursor: "pointer" }} onClick={() => handleCobrowseMenuClick()}>
                        <Airplay fontSize="medium" />
                        <Box>
                            <Typography variant="body1">{t("helpMenu.cobrowse")}</Typography>
                            <Typography variant="body2">{t("helpMenu.cobrowseDescription")}</Typography>

                            {
                            cobrowseCode && <Alert severity="info"
                                        sx={{
                                            marginTop: 1,
                                        }}>
                                        {t('helpMenu.cobrowseCodeText', {code: cobrowseCode})}
                                    </Alert>
                            }

                        </Box>
                    </Stack>




                    <Typography variant="h5" sx={{marginTop: 4}}>{t("helpMenu.legal")}</Typography>
                    
                    <Stack direction="row" spacing={4} sx={{ marginTop: 2, cursor: "pointer" }} onClick={() => handleHelpMenuClick(_termsOfServiceHref)}>
                        <Gavel fontSize="medium" />
                        <Box>
                            <Typography variant="body1">{t("helpMenu.termsOfService")}</Typography>
                        </Box>
                    </Stack>

                    <Stack direction="row" spacing={4} sx={{ marginTop: 2, cursor: "pointer" }} onClick={() => handleHelpMenuClick(_privacyPolicyHref)}>
                        <Policy fontSize="medium" />
                        <Box>
                            <Typography variant="body1">{t("helpMenu.privacyPolicy")}</Typography>
                        </Box>
                    </Stack>

                    <Typography variant="h5" sx={{marginTop: 4}}>{t("helpMenu.about")}</Typography>
                    
                    <Stack direction="row" spacing={4} sx={{ marginTop: 2 }}>
                        <Info fontSize="medium" />
                        <Box>
                            <Typography variant="body1">{t("helpMenu.version", {version: appVersion})}</Typography>
                        </Box>
                    </Stack>
                </DialogContent>

            </FullScreenDialog>
    );
}